<template>
    <div class="ppa-quote-panel">
        <div v-show="infoMessage" class="alert alert-info alert-dismissible">
            <span class="close" data-dismiss="alert" aria-label="close" v-on:click="infoMessage = null">&times;</span>
            <p v-text="infoMessage"></p>
        </div>

        <ppa-quote v-model="ppaQuoteLocalData" :is-editable="true"></ppa-quote>
        <div class="commands">
            <div style="position: absolute; left: 0">
                <div class="form-group d-inline-block" style="margin: 0 10px; text-align: left">
                    <label for="toMail">To email</label>
                    <input type="text" name="toMail" style="width: 250px; height: 45px"  v-model="toMail" class="form-control">
                </div>
                <button class="d-inline-block btn btn-lg btn-danger" v-on:click="onSendMail">Send email</button>

            </div>
            <div style="position: absolute; right: 0; bottom: 0">
            <button v-on:click="onSave(true)" class="d-inline-block btn btn-lg btn-info">Download PDF</button>
            <button v-on:click="onSave(false)" class="d-inline-block btn btn-lg btn-danger">Save</button>
            </div>
        </div>
        <div v-show="isBusy" class="loader-overlay">
            <div class="loader"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            defaultEmail: String,
            data: Object,
        },
        name: "ppa-quote-page",
        data() {
            return {
                toMail: this.defaultEmail,
                ppaQuoteLocalData: null,
                isBusy: false,
                infoMessage: null
            };
        },
        methods: {
            onSave(downloadPdf){
                this.isBusy = true;

                axios.post(url(`admin/quotes/${this.data.quote_id}/ppa-quote`), {
                      ppaQuoteData: this.ppaQuoteLocalData
                    }).then((response) => {
                        if(response.status == 200) {
                            if(downloadPdf){
                                window.location.replace(url(`admin/quotes/${this.data.quote_id}/ppa-quote-download-pdf`));
                                this.infoMessage = "PDF will be downloaded in few seconds.";
                            }
                            else{
                                this.infoMessage = "All saved";
                            }
                        }
                        else {
                            this.infoMessage = "Save failed, please try again later.";
                        }
                }).finally(() => {this.isBusy = false;})
            },
            onSendMail() {
                this.isBusy = true;
                axios.post(url(`admin/quotes/${this.data.quote_id}/ppa-quote-send-mail`), {
                        toMail: this.toMail,
                        ppaQuoteData: this.ppaQuoteLocalData
                    }).then((response) => {
                        if(response.status == 200) {
                            this.infoMessage = "PPA quote saved and sent to email " + this.toMail;
                        }
                        else{
                            this.infoMessage = "Something went wrong, please try again later.";
                        }
                    }).finally(() => {this.isBusy = false;})
            },
        },
        mounted() {
            this.ppaQuoteLocalData = _.cloneDeep(this.data);
        }
    }
</script>

<style scoped>

    .d-inline-block{
        display: inline-block;
    }

    .ppa-quote-panel .commands {
        margin-bottom: 20px;
        position: relative;
        text-align: right;
        right: 0;
    }

    .loader-overlay{
        background-color: rgba(0, 0, 0, 0.3);
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 99999999;
    }

    @keyframes spin {
        from {transform:rotate(0deg);}
        to {transform:rotate(360deg);}
    }
    .loader {
        border: 8px solid #f3f3f3;
        border-top: 8px solid #3498db;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 2s linear infinite;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -2.2em;
        margin-left: -2.2em;
    }

    .commands {
        position: relative;
        margin: 40px 0px 0 0px;
        height: 70px;
    }
</style>